import './circular_spinner.less';

import React from 'react';
import classNames from 'classnames';

export const CircularSpinner = ({ className, width, height })=> 
  <div className={classNames('circular-spinner', className)}  style={{width:width, height:height}}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>;


export default CircularSpinner;
